import { createAction } from 'actions/utils';
import {
    GET_LITERALS_REQUEST,
    GET_LITERALS_SUCCESS,
    GET_LITERALS_ERROR,
} from 'constants/ActionTypes';
import { Core } from 'managers';

export function getLiterals(lang, impl) {
    return (dispatch) => {
        dispatch(createAction(GET_LITERALS_REQUEST, {}));
        return Core.literalsManager.getLiterals(lang, impl || -1).then(
            (response) => {
                dispatch(createAction(GET_LITERALS_SUCCESS, response));
            },
            (error) => {
                dispatch(
                    createAction(GET_LITERALS_ERROR, {
                        error: true,
                        errorType: error,
                    }),
                );
                throw error;
            },
        );
    };
}
